<script>
import { mapActions } from "vuex";
import errorMixin from "@/mixins/errorMixin";
import Modal from "@/components/_Shared/Modal";
import Phone from "@/components/_Shared/Forms/Phone";
import InputGroup from "@/components/_Shared/InputGroup";

export default {
  mixins: [errorMixin],
  components: {
    Modal,
    InputGroup,
    Phone
  },
  data() {
    return {
      preloader: false,
      professional: {
        mei: "",
        cpf: ""
      },
      account: {
        email: "",
        first_name: "",
        last_name: "",
        password: "",
        password_confirmation: ""
      },
      profile: {
        profile_picture: "",
        birthdate: "",
        state_name: "",
        city_name: ""
      },
      phones: [
        {
          country_code: "",
          area_code: "",
          number: ""
        }
      ],
      address: {
        street: "",
        street_number: "",
        complement: "",
        district: "",
        city: "",
        state: "",
        country: "BRA",
        zip_code: ""
      }
    };
  },
  methods: {
    ...mapActions("professionals", ["create"]),

    async submit() {
      this.preloader = true;

      try {
        let valid = await this.$validator.validateAll();

        if (valid) {
          await this.create({
            professional: this.professional,
            account: this.account,
            profile: this.profile,
            phones: this.phones,
            address: this.address
          });
          this.$emit("close");
          this.$emit("refresh");
        }
      } catch (error) {
        this.preloader = false;
        this.inputErrors(error);
        this.$emit("errorMessage", error[0].detail);
      }

      this.preloader = false;
    }
  }
};
</script>

<template>
  <modal
    title="NOVO PROFISSIONAL"
    subtitle="Cadastre um novo profissional"
    size="lg"
    @close="$emit('close')"
  >
    <template slot="body" class="professional">
      <v-layout row class="title-form">PESSOAL</v-layout>
      <!-- MEI AND CPF -->
      <v-layout align-center justify-space-between row fill-height wrap>
        <v-flex px-1 md6 xs12>
          <v-text-field
            name="mei"
            label="mei"
            v-model="professional.mei"
            mask="##.###.###/####-##"
            v-validate="'numeric'"
            :error-messages="errors.first('mei')"
            :error="errors.has('mei')"
          />
        </v-flex>
        <v-flex px-1 md6 xs12>
          <v-text-field
            name="cpf"
            label="cpf"
            v-model="professional.cpf"
            mask="###.###.###-##"
            v-validate="'numeric|required'"
            :error-messages="errors.first('cpf')"
            :error="errors.has('cpf')"
          />
        </v-flex>
      </v-layout>
      <!-- EMAIL AND BIRTHDATE -->
      <v-layout align-center justify-space-between row fill-height wrap>
        <v-flex px-1 md6 xs12>
          <v-text-field
            name="email"
            v-model="account.email"
            label="email"
            :error="errors.has('email')"
            :error-messages="errors.first('email')"
            v-validate.disabled="'required|email'"
          />
        </v-flex>
        <v-flex px-1 md6 xs12>
          <v-text-field
            name="data de nascimento"
            label="data de nascimento"
            v-model="profile.birthdate"
            v-mask="'##/##/####'"
            v-validate="'required'"
            :error-messages="errors.first('data de nascimento')"
            :error="errors.has('data de nascimento')"
          />
        </v-flex>
      </v-layout>
      <!-- PHONES -->
      <v-layout align-center justify-space-between row fill-height wrap>
        <v-flex px-1 md6 xs12>
          <Phone v-model="phones[0]" label="celular" />
        </v-flex>
        <v-flex px-1 md6 xs12>
          <Phone v-model="phones[1]" label="outro celular" />
        </v-flex>
      </v-layout>
      <!-- FIRST AND LAST NAME -->
      <v-layout align-center justify-space-between row fill-height wrap>
        <v-flex px-1 md6 xs12>
          <v-text-field
            name="nome"
            label="nome"
            v-model="account.first_name"
            custom-classes="capitalize"
            v-validate="'required|alpha_spaces'"
            :error-messages="errors.first('nome')"
            :error="errors.has('nome')"
          />
        </v-flex>
        <v-flex px-1 md6 xs12>
          <v-text-field
            name="sobrenome"
            label="sobrenome"
            v-model="account.last_name"
            v-validate="'required|alpha_spaces'"
            :error-messages="errors.first('sobrenome')"
            :error="errors.has('sobrenome')"
          />
        </v-flex>
      </v-layout>
      <!-- PASSWORD AND CONFIRM PASSWORD -->
      <v-layout align-center justify-space-between row fill-height wrap>
        <v-flex px-1 md6 xs12>
          <v-text-field
            name="senha"
            v-model="account.password"
            label="senha"
            :error-messages="errors.first('senha')"
            :error="errors.has('senha')"
            v-validate="'required|min:8'"
            ref="senha"
            type="password"
          />
        </v-flex>

        <v-flex px-1 md6 xs12>
          <v-text-field
            name="confirmação da senha"
            v-model="account.password_confirmation"
            label="confirme a senha"
            :error="errors.has('confirmação da senha')"
            :error-messages="errors.first('confirmação da senha')"
            v-validate="'required|min:8|confirmed:senha'"
            type="password"
          />
        </v-flex>
      </v-layout>
      <!-- STATE, CITY -->
      <v-layout align-center justify-space-between row fill-height wrap>
        <v-flex px-1 md6 xs12>
          <v-text-field
            name="cidade de atuação"
            v-model="profile.city_name"
            label="cidade de atuação"
            :error-messages="errors.first('cidade de atuação')"
            :error="errors.has('cidade de atuação')"
            v-validate="'required|alpha_spaces'"
          />
        </v-flex>

        <v-flex px-1 md6 xs12>
          <v-text-field
            name="UF de atuação"
            v-model="profile.state_name"
            label="UF de atuação"
            :error="errors.has('UF de atuação')"
            :error-messages="errors.first('UF de atuação')"
            v-validate="'required|alpha|length:2'"
          />
        </v-flex>
      </v-layout>
      <v-layout row mb-10 class="title-form">ENDEREÇO</v-layout>
      <!-- STREET, COMPLEMENT, ZIP CODE AND NUMBER -->
      <v-layout align-center justify-space-between row fill-height wrap>
        <v-flex px-1 md5 xs12>
          <v-text-field
            name="rua"
            v-model="address.street"
            label="rua"
            :error-messages="errors.first('rua')"
            :error="errors.has('rua')"
            v-validate="'required'"
          />
        </v-flex>

        <v-flex px-1 md2 xs12>
          <v-text-field
            name="número"
            v-model="address.street_number"
            label="número"
            :error="errors.has('número')"
            :error-messages="errors.first('número')"
            v-validate="'required'"
          />
        </v-flex>

        <v-flex px-1 md3 xs12>
          <v-text-field
            name="complemento"
            v-model="address.complement"
            label="complemento"
            :error-messages="errors.first('complemento')"
            :error="errors.has('complemento')"
          />
        </v-flex>

        <v-flex px-1 md2 xs12>
          <v-text-field
            name="cep"
            v-model="address.zip_code"
            label="cep"
            :error="errors.has('cep')"
            :error-messages="errors.first('cep')"
            v-validate="'required|numeric'"
            mask="#####-###"
          />
        </v-flex>
      </v-layout>
      <!-- STATE, CITY AND DISTRICT -->
      <v-layout align-center justify-space-between row fill-height wrap>
        <v-flex px-1 md4 xs12>
          <v-text-field
            name="bairro"
            v-model="address.district"
            label="bairro"
            :error="errors.has('bairro')"
            :error-messages="errors.first('bairro')"
            v-validate="'required'"
          />
        </v-flex>

        <v-flex px-1 md4 xs12>
          <v-text-field
            name="cidade"
            v-model="address.city"
            label="cidade"
            :error-messages="errors.first('cidade')"
            :error="errors.has('cidade')"
            v-validate="'required'"
          />
        </v-flex>

        <v-flex px-1 md4 xs12>
          <v-text-field
            name="UF"
            v-model="address.state"
            label="UF"
            :error="errors.has('UF')"
            :error-messages="errors.first('UF')"
            v-validate="'required|alpha|length:2'"
          />
        </v-flex>
      </v-layout>
    </template>

    <template slot="footer">
      <button class="btn bg-purple-outline" @click="$emit('close')">
        fechar
      </button>
      <button
        class="btn bg-purple"
        :class="{ 'btn--loading': preloader }"
        @click="submit"
      >
        <span>cadastrar</span>
      </button>
    </template>
  </modal>
</template>

<style scoped>
.upload-photo {
  width: 30%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid var(--purple);
  opacity: 0.6;
  transition: all 0.24s ease;
  cursor: pointer;
  margin-right: 20px;
}

.upload-photo:hover {
  opacity: 1;
}

.upload-photo img {
  width: 50px;
  object-fit: contain;
}

@media (max-width: 960px) {
  .upload-photo {
    width: 100%;
    padding: 20px 0;
  }

  .flex-direction-row {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Professionals/NewProfessional.vue